import { Controller } from "@hotwired/stimulus"

// Pojedynczy wybór użytkownika (np. właściciel firmy). Wyświetla: "Imię Nazwisko (email)"
export default class extends Controller {
  static targets = ["input", "results", "ownerId", "display"]
  static values = { url: String }

  connect() {
    this.timeout = null
    this.selectedUser = null
    this.loadExistingOwner()
    document.addEventListener("click", this.handleClickOutside.bind(this))
  }

  loadExistingOwner() {
    const hiddenInput = this.hasOwnerIdTarget ? this.ownerIdTarget : this.element.querySelector('input[name="company[owner_id]"]')
    const displayEl = this.element.querySelector('.sc-recipient-chip-name')
    if (hiddenInput?.value && displayEl) {
      this.selectedUser = {
        id: hiddenInput.value,
        display: displayEl.textContent.trim()
      }
    }
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside.bind(this))
  }

  search() {
    clearTimeout(this.timeout)
    const query = this.inputTarget?.value?.trim() || ""

    if (query.length < 2) {
      this.hideResults()
      return
    }

    this.timeout = setTimeout(() => {
      this.fetchResults(query)
    }, 250)
  }

  inputFocus() {
    if (this.inputTarget.value.trim().length >= 2) {
      this.search()
    }
  }

  async fetchResults(query) {
    if (!this.urlValue?.trim()) {
      console.warn("user-autocomplete: url value not set")
      return
    }

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set('q', query)

    try {
      const response = await fetch(url, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        credentials: "same-origin"
      })

      if (!response.ok) throw new Error(`Server error: ${response.status}`)

      const users = await response.json()
      this.renderResults(users)
    } catch (error) {
      console.error("Error fetching users:", error)
      this.renderResults([])
    }
  }

  renderResults(users) {
    if (users.length === 0) {
      this.resultsTarget.innerHTML = `
        <div class="sc-padding-small uk-text-center uk-text-muted uk-text-small">
          Nie znaleziono użytkowników
        </div>
      `
      this.showResults()
      return
    }

    this.resultsTarget.innerHTML = users.map(user => {
      const display = user.display || `${user.name} (${user.email})`
      const avatarUrl = user.avatar_url
      const initials = user.initials || '?'
      const avatarHtml = (avatarUrl && !avatarUrl.includes('defaults/avatar.png'))
        ? `<img src="${avatarUrl}" alt="${user.name}">`
        : `<span class="sc-avatar-initials">${initials}</span>`

      return `
        <div class="sc-autocomplete-item" data-action="click->user-autocomplete#select" data-user='${JSON.stringify({ id: user.id, display }).replace(/'/g, "&#39;")}'>
          <div class="sc-autocomplete-info">
            <div class="sc-autocomplete-avatar">${avatarHtml}</div>
            <div class="sc-autocomplete-details">
              <span class="sc-autocomplete-name">${user.name}</span>
              <span class="sc-autocomplete-email">${user.email}</span>
            </div>
          </div>
        </div>
      `
    }).join("")

    this.showResults()
  }

  select(event) {
    const userData = event.currentTarget.dataset.user
    const user = JSON.parse(userData)
    this.selectedUser = user
    this.ownerIdTarget.value = user.id
    this.inputTarget.value = ""
    this.hideResults()
    this.renderDisplay()
  }

  clear(event) {
    if (event) event.preventDefault()
    this.selectedUser = null
    this.ownerIdTarget.value = ""
    this.renderDisplay()
  }

  renderDisplay() {
    const chipContainer = this.hasDisplayTarget ? this.displayTarget : this.element.querySelector('[data-user-autocomplete-target="display"]')
    if (!chipContainer) return

    if (this.selectedUser) {
      chipContainer.innerHTML = `
        <span class="sc-recipient-chip">
          <span class="sc-recipient-chip-name">${this.selectedUser.display}</span>
          <a href="#" data-action="click->user-autocomplete#clear">
            <i class="mdi mdi-close"></i>
          </a>
        </span>
      `
      chipContainer.style.display = ""
    } else {
      chipContainer.innerHTML = ""
      chipContainer.style.display = "none"
    }
  }

  showResults() {
    this.resultsTarget.classList.remove("uk-hidden")
  }

  hideResults() {
    this.resultsTarget.classList.add("uk-hidden")
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideResults()
    }
  }

}
